module.exports = __webpack_public_path__ + "img/texture-3.aa858d39.png";